const LEGACY_JD_REFERENCE_PATTERN = /^(JD\d{12})(?:_(\d+))?$/i;
const LEGACY_JD_REFERENCE_IN_TEXT_PATTERN = /\bJD\d{12}(?:_\d+)?\b/i;

export type LegacyJdReference = {
  batchNo: string;
  referenceKey: string;
  versionSeq?: number;
};

/** 解析旧系统 JD 定制号，格式为 JDyyyyMMddNNNN 或 JDyyyyMMddNNNN_version。 */
export function parseLegacyJdReference(value?: string | null): LegacyJdReference | null {
  const matched = value?.trim().match(LEGACY_JD_REFERENCE_PATTERN);
  if (!matched) {
    return null;
  }
  const batchNo = matched[1].toUpperCase();
  const versionSeq = matched[2] ? Number(matched[2]) : undefined;
  if (versionSeq !== undefined && (!Number.isSafeInteger(versionSeq) || versionSeq <= 0)) {
    return null;
  }
  return {
    batchNo,
    referenceKey: versionSeq ? `${batchNo}_${versionSeq}` : batchNo,
    versionSeq,
  };
}

/** 从自然语言追溯中提取首个旧系统 JD 定制号。 */
export function findLegacyJdReferenceKey(content: string): string | null {
  const matched = content.match(LEGACY_JD_REFERENCE_IN_TEXT_PATTERN);
  return parseLegacyJdReference(matched?.[0])?.referenceKey ?? null;
}
